import { StatusPermission } from '../../enum';
import { useUserPermissionsAPI } from './selectors';
/**
 * Whether Financials is hidden from the current user: the org has no Financials licence, or the
 * user's own Financials permission is Hide (useUserPermissionsAPI folds the two together).
 *
 * Kept out of selectors.tsx so that tests mocking useUserPermissionsAPI also drive this hook.
 */
export var useIsFinancialHidden = function () { var _a; return ((_a = useUserPermissionsAPI()) === null || _a === void 0 ? void 0 : _a.financialPermission) === StatusPermission.Hide; };
